import { Box, Spinner } from '@factorialco/deprecated-design-system'
import { FormInsightsOverviewElementFragment } from 'generated/resources/graphql'

import { ChartWidget } from 'modules/engagement_surveys/components/FormInsightsOverview/InsightsVisualization/ChartWidget'

interface Props {
  element: FormInsightsOverviewElementFragment
}

export function LoadingState({ element }: Props) {
  return (
    <ChartWidget
      title={element.label}
      description={element.description || ''}
      questionType={element.type}
    >
      <Box alignItems="center" justifyContent="center" height="full">
        <Spinner />
      </Box>
    </ChartWidget>
  )
}
